import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import notifier from './notifier.js';
import master from './master.js';
import accounts from './accounts.js';
import advisors from './advisors.js';
import users from './users.js';
import notifications from './notifications.js';
import adjudication from './adjudication.js';
import invoices from './invoices.js';
import quotes from './quotes.js';
import loader from './loader.js';

/**
 * 
 * @param {*} history 
 * @returns 
 */
const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    notifier,
    master,
    accounts,
    advisors,
    users,
    notifications,
    adjudication,
    invoices,
    quotes,
    loader
//   ... // rest of your reducers
});

export default rootReducer;